import { LayoutGrid, Zap, Ruler, Gauge, Cpu, Sparkles, Building2 } from "lucide-react";

const nfmt = (n) => Number(n).toLocaleString("it-IT", { maximumFractionDigits: 1 });

// Mostra SEMPRE, in evidenza, quale pannello si sta dimensionando: foto, descrizione e caratteristiche.
export function PanelInUse({ module, className = "", freeArea = false }) {
  const m = module || {};
  const model = m.model || "Modulo standard";
  const w = m.larghezza_mm, l = m.lunghezza_mm, wp = m.potenza_wp;
  const brand = m.brand;
  const eff = m.efficienza;
  const tech = m.tecnologia;
  const photo = m.photo_url;
  const descr = m.descrizione;
  const src = m.source;
  const isFallback = !!m.reference || m.provided === false;
  const srcLabel = src === "rete.torri.solar" ? "fornito da rete.torri.solar"
    : src === "vetrina" ? "dalla Vetrina Free"
    : src === "prsg_riferimento" ? "riferimento PRSG"
    : src === "catalogo" ? "pannello di default (da catalogo)"
    : null;

  const chips = [];
  if (wp) chips.push({ icon: Zap, label: `${Math.round(wp)} Wp` });
  if (w && l) chips.push({ icon: Ruler, label: `${Math.round(w)}×${Math.round(l)} mm` });
  if (eff) chips.push({ icon: Gauge, label: `${nfmt(eff)}% efficienza` });
  if (tech) chips.push({ icon: Cpu, label: tech });

  return (
    <div
      className={`rounded-xl border-2 shadow-sm overflow-hidden ${isFallback ? "border-amber-400/60 bg-amber-50/60 dark:bg-amber-950/20" : "border-primary/40 bg-gradient-to-br from-primary/[0.07] to-transparent"} ${className}`}
      data-testid="panel-in-use"
    >
      <div className="flex items-stretch gap-3 p-3">
        {/* Foto pannello */}
        <div className="shrink-0 w-24 h-24 rounded-lg overflow-hidden border border-border bg-secondary/30 flex items-center justify-center" data-testid="panel-in-use-photo">
          {photo ? (
            <img src={photo} alt={model} className="w-full h-full object-cover" />
          ) : (
            <LayoutGrid className="h-8 w-8 text-muted-foreground/50" strokeWidth={1.5} />
          )}
        </div>
        {/* Info pannello */}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wide text-primary font-semibold">
            <Sparkles className="h-3 w-3" /> Pannello in dimensionamento{isFallback ? " · di riferimento" : ""}
          </div>
          <div className="text-base font-bold leading-tight mt-0.5 truncate" data-testid="panel-in-use-model">{model}</div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-0.5">
            {brand ? <span className="inline-flex items-center gap-1"><Building2 className="h-3 w-3" />{brand}</span> : null}
            {brand && srcLabel ? <span>·</span> : null}
            {srcLabel ? <span>{srcLabel}</span> : null}
          </div>
          {descr ? <p className="text-xs text-foreground/70 mt-1.5 line-clamp-3">{descr}</p> : null}
          {chips.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-2" data-testid="panel-in-use-specs">
              {chips.map((c, i) => (
                <span key={i} className="inline-flex items-center gap-1 rounded-full border border-border bg-background/70 px-2 py-0.5 text-[11px] font-medium">
                  <c.icon className="h-3 w-3 text-primary" /> {c.label}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
